<template>
    <div class="d-flex flex-column width-max-600 mx-auto pt-4 pb-5">
        <h2><b-badge variant="light" class="rounded"><feather type="bell" /></b-badge></h2>
        <h4>{{ $t('addYourFirstConfiguration') }}</h4>
        <p class="font-size-16">{{ $t('addYourFirstConfigurationDescription') }}</p>
        <b-link variant="link" class="mr-auto mb-3" target="_blank" href="https://getbuybox.com/konfiguracje/">{{ $t('learnMoreAboutConfigurations') }}</b-link>
        <ButtonIcon icon="plus" class="mr-auto" @click="parentComponent.addConfiguration()">{{ $t('addConfiguration') }}</ButtonIcon>
    </div>
</template>



<script>
    export default {
        name: 'AddFirstConfiguration',
        inject: {
            parentComponent: {
                default: null,
            },
        },
    };
</script>
